module.exports = __webpack_public_path__ + "img/none.732aaa8e.png";